import React, { useMemo } from "react";
import { Field } from "react-final-form";

import RffInputWrapper from "../shared/RffInputWrapper";

import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";

import SelectToggleInput from "../../inputs/SelectToggleInput";

const RffSelectToggleField = ({
  name,
  label,
  options,
  required = false,
  row = false,
  compact = false,
  suppressGrid,
  size,
  toggleSize,
  disabled,
  onChange,
  alphabetize = false,
  helperText,
  testing,
}) => {
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  const sortedOptions = useMemo(() => {
    if (!alphabetize || !options) return options;

    return [...options].sort((a, b) => {
      // Handle different option formats
      const labelA =
        typeof a === "string" ? a : a?.label || a?.name || String(a);
      const labelB =
        typeof b === "string" ? b : b?.label || b?.name || String(b);

      return labelA.localeCompare(labelB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
  }, [options, alphabetize]);

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      testing={testing}
      required={required}
      helperText={helperText}
      row={row}
      compact={compact}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => (
          <SelectToggleInput
            label={label}
            value={input?.value}
            disabled={disabled}
            onChange={(v) => {
              input.onChange(v);
              if (onChange) {
                onChange(v);
              }
            }}
            // sx={{ mt: 1 }}
            size={toggleSize}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
            options={sortedOptions}
          />
        )}
      />
    </RffInputWrapper>
  );
};

export default RffSelectToggleField;
